<template>
  <v-row>
    <v-col cols="12" md="6">
      <div>
        <slot name="fechas" />
      </div>
      <v-row>
        <v-col cols="6">
          <v-text-field v-model="total" color="gold" label="Total contrato" type="number" step="0.01" max="999999999" :readonly="mode === 'show'" />
        </v-col>
        <v-col cols="6">
        <v-select v-model="monedaSelected" color="gold" :items="monedas" label="Moneda" return-object item-text="descripcion">
          <template v-slot:itemm="{ attrs, itemm, on }">
            <v-list-item v-bind="attrs" active-class="gold elevation-4 white--text" class="mx-3 mb-3 v-sheet" elevation="0" v-on="on">
              <v-list-item-content>
                <v-list-item-title v-text="itemm.descripcion" />
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </v-col>
        <v-col cols="12">
          <base-upload-files folder="/documentaciones/contratos" :documento-id="idArchivo" tipo='pdf' @documento="newFile = $event" />
        </v-col>
      </v-row>
    </v-col>
    <v-col  cols="12" md="6">
      <validation-provider v-slot="{ errors }" name="descripcion" rules="max:250">
        <v-textarea v-model="newDescripcion" :error-messages="errors" color="gold" name="input-6-1" rows="9" label="Descripción" :readonly="mode === 'show'" />
      </validation-provider>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'DatosContrato',
    props: {
      montoTotal: {
        type: Number,
        required: false,
        default: 0,
      },
      descripcion: {
        type: String,
        required: false,
        default: '',
      },
      fileId: {
        type: Number,
        required: false,
        default: 0,
      },
      monedaId: {
        type: Number,
        required: false,
        default: 0,
      },
      mode: {
        type: String,
        required: false,
        default: null,
      },
    },
    data () {
      return {
        total: this.montoTotal,
        idArchivo: this.fileId,
        newFile: null,
        newDescripcion: this.descripcion,
        monedas: [],
        monedaSelected: {},
      }
    },
    created () {
      this.getMonedas()
    },
    watch: {
      monedaSelected (val) {
        if (val) {
          this.$emit('monedaChange', val.id)
        }
      },
      total (val) {
        this.$emit('totalChange', parseFloat(val, 10))
      },
      newFile (val) {
        if (val !== null) {
          this.$emit('fileChange', val)
        }
      },
      newDescripcion (val) {
        this.$emit('descripcionChange', val)
      },
      montoTotal (val) {
        this.total = val
      },
      descripcion (val) {
        this.newDescripcion = val
      },
      fileId (val) {
        this.idArchivo = val
      },
    },
    methods: {
      getMonedas () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/moneda' }).then(response => {
          this.monedas = response
          if (this.monedaId !== 0) {
            this.monedaSelected = this.monedas.find(e => e.id === this.monedaId)
          }
        })
      },
    },
  }
</script>
